<template>
    <div id="tst">
        <v-tooltip bottom>
            <v-chip
                      class="vinculoChip"
                      small
                      color="primary"
                      text-color="white"
                      slot="activator"
                      @click.stop="dialog = true"
                      
                  >
                    NF-e
          </v-chip>
            <span>Visualizar Nota Fiscal Eletrônica vinculada a esta nota</span>
        </v-tooltip>  
                    <v-dialog @keydown.esc="dialog = false"
                    v-model="dialog"
                    
                    fullscreen
                    :lazy="true"
                    >

    
                        <v-card>
                            <v-card-title
                            class="headline darkBlue text-xs-center"
                            text-color="white"
                            style="color: white;"
                            primary-title
                            
                            >
                            Nf-e Vinculadas
                            <v-spacer></v-spacer>
                            <div id="listaNfe">
                              <span>NF-e Vinculadas</span>
                              <ol v-if="nota.item.nfe.length > 0">
                                <li v-for="chave in nota.item.nfe" :key="chave" @click="getNFeVinculada(chave)">
                                  <h6>
                                    {{chave}}
                                  </h6>
                                </li>
                              </ol>
                            </div>
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click.native="dialog = false">
                                <v-icon>close</v-icon>
                            </v-btn>
                            </v-card-title>

                            <v-card-text id="bodyNFeVinculada">
                              <h2 v-if="nota.item.nfe.length > 0" class="text-xs-center">{{text_info}}</h2>
                              <h2 v-else class="text-xs-center red--text">Nenhuma nota vinculada</h2>
                              <object v-if="this.danfeB64 != '' && this.text_info != ''" type="text/html" data="https://www.nfe.fazenda.gov.br/portal/consultaRecaptcha.aspx?tipoConsulta=completa&tipoConteudo=XbSeqxE8pl8=" style="width:100%; height:90vh"></object>
                            </v-card-text>

                            <v-divider></v-divider>

                            <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="primary"
                                flat
                                @click="dialog = false"
                            >
                                Fechar
                            </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
    </div>

</template>
<script>
import CteService from "@/domain/notas/cte/CteService";
export default {
  props: ["nota"],
  data() {
    return {
      dialog: false,
      danfeB64: "",
      text_info: "Clique na chave para exibir a nota"
    };
  },
  watch: {},
  computed: {},
  methods: {
    getNFeVinculada: async function(chave) {
      this.service = new CteService(this.$http);
      await this.service
        .getNfeByChave(chave)
        .then(success => (this.danfeB64 = success));
      this.setPdfData();
    },
    setPdfData: function() {
      if (this.danfeB64) {
        this.text_info = "";
        if (document.getElementById("pdf")) {
          document.getElementById("pdf").remove();
        }
        var embed = document.createElement("EMBED");
        embed.setAttribute(
          "src",
          "data:application/pdf;base64," + encodeURIComponent(this.danfeB64)
        );
        embed.setAttribute("id", "pdf");
        document.querySelector("#bodyNFeVinculada").appendChild(embed);
      } else {
        this.text_info =
          "Nota não encontrada em nosso sistema, disponivel somente em consulta individual no sefaz";
      }
    }
  }
};
</script>
<style>
#tst {
  display: inline-block;
}
#lista {
  padding: 20px;
}
embed {
  width: 100%;
  height: 90vh;
}
#listaNfe ol {
  cursor: pointer;
}
#listaNfe {
  margin-left: -109px;
}
</style>



// WEBPACK FOOTER //
// src/components/dataTable/commonTable/coluna_vinculo/btnNFeVinculadas/BtnNFeVinculadas.vue